if (!window.blogFilterArticlesDefined) {
  class blogFilterArticles extends HTMLElement{
    constructor(){
      super();
      this.selector = this.dataset.selector;
      this.defaultPill = this.querySelector('.blog-filter-pill--default');
      this.blogFilterPills = this.querySelectorAll(`.${this.selector} .blog-filter-pill`);
      this.activeClass = 'active';
      this.docTitle = this.dataset.doctitle;
    }

    connectedCallback() {
      // Add an event listener to the select element
      this.blogFilterPills.forEach((pill) => {
        pill.addEventListener('click', this.handleClick.bind(this, pill));
      })
    }

    handleClick (pill, event) {
      event.preventDefault();

      const isActive = pill.classList.contains(this.activeClass);

      this.blogFilterPills.forEach((p) => p.classList.remove(this.activeClass));
      
      let path;
      if (isActive) {
        // Reset to initial state if the active pill is clicked
        path = pill.dataset.restorePath;
        if (this.defaultPill) {
          this.defaultPill.classList.add(this.activeClass);
        }
      } else {
        // Add the active class to the clicked pill
        pill.classList.add(this.activeClass);
        path = pill.dataset.path;
      }
      
      // Re-render the articles section with the new filter or restore to initial state
      fetch(path)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const targetElement = document.querySelector(`.blog-articles-container.${this.selector}`);
          console.log(targetElement);
          const sourceElement = html.querySelector(`.blog-articles-container.${this.selector}`);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
          // Change url to hide pagination params without reloading
          if (pill.dataset.restorePath) {
            window.history.pushState({}, '', pill.dataset.restorePath); 
          }
          // Change document title to hide pagination params
          if (this.docTitle) {
            document.title = this.docTitle;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('blog-filter-articles', blogFilterArticles); 
window.blogFilterArticlesDefined = true;
}